export const dividends = () => {

    const yearFilter = $('#dividends-filter--year');
    const dividendYears = $('.dividends--list--year');

    if (yearFilter.length > 0) {
        // Helper function to convert string to slug (similar to PHP's sanitize_title)
        function sanitizeTitle(str) {
            if (!str) return '';
            return str.toLowerCase()
                .replace(/[^\w\s-]/g, '') // Remove special characters
                .replace(/\s+/g, '-')     // Replace spaces with hyphens
                .replace(/-+/g, '-')       // Replace multiple hyphens with single hyphen
                .trim();
        }

        // Helper function to filter dividend years (supports single or multiple selection)
        function filterDividendYears(selected) {
            const selectedValues = selected == null ? [] : (Array.isArray(selected) ? selected : [selected]).filter(Boolean);

            if (selectedValues.length === 0) {
                dividendYears.removeClass("is-hidden");
                return;
            }

            const selectedSlugs = selectedValues.map(function(v) { return sanitizeTitle(v); });

            dividendYears.each(function() {
                const $year = $(this);
                let show = false;
                selectedSlugs.forEach(function(slug) {
                    if ($year.hasClass('dividends--list--year--' + slug)) show = true;
                });
                if (show) {
                    $year.removeClass("is-hidden");
                } else {
                    $year.addClass("is-hidden");
                }
            });
        }

        // When the option with no value (e.g. "All") is selected: clear all values and close dropdown
        function selectedHasEmptyValue(selected) {
            const arr = Array.isArray(selected) ? selected : (selected != null ? [selected] : []);
            return arr.indexOf('') !== -1 || arr.some(function(v) { return v == null || v === ''; });
        }

        function clearAllAndClose($select) {
            $select.val([]);
            // Explicitly deselect every option so the value is fully cleared (including empty-value "All")
            $select.find('option').prop('selected', false);
            if ($select.data('selectric')) {
                $select.selectric('refresh');
                $select.selectric('close');
            } else {
                $select.blur();
            }
            filterDividendYears([]);
        }

        yearFilter.on('selectric-select', function(event, element, selectric) {
            const $select = $(this);
            const val = $select.val();
            if (selectedHasEmptyValue(val)) {
                clearAllAndClose($select);
            }
        });

        yearFilter.on('selectric-change', function(event, element, selectric) {
            const $select = $(this);
            if (selectedHasEmptyValue($select.val())) return;
            filterDividendYears($select.val());
        });

        yearFilter.on('change', function() {
            const $select = $(this);
            let selectedYear = $select.val();
            if (selectedHasEmptyValue(selectedYear)) {
                clearAllAndClose($select);
                return;
            }
            filterDividendYears(selectedYear);
        });
    }
};